import React from 'react'
import { Chat } from 'stream-chat-react'
import 'stream-chat-react/dist/css/v2/index.css'
import './style-overrides.css'
import LinearProgress from '@material-ui/core/LinearProgress'
import { useStreamClient } from './hooks'

const withStreamClient = Component => props => {
  const streamClient = useStreamClient()

  if (!streamClient) return <LinearProgress color="primary" />

  return (
    <Chat client={streamClient}>
      <Component {...props} />
    </Chat>
  )
}

export default withStreamClient
